import { isEmpty } from 'lodash';
import React from 'react';
import { StyleProp, TextStyle } from 'react-native';
import { MBView, MBViewProps } from '@shared/components/MBView';
import { MBText } from '../text';

interface Props extends MBViewProps {
  beginning: string;
  end?: string;
  textStyle?: StyleProp<TextStyle>;
}

export function TruncateMiddle({ beginning, end = '', textStyle, ...otherProps }: Props) {
  return (
    <MBView row {...otherProps}>
      <MBText numberOfLines={1} style={[{ flexShrink: 1 }, truncationStyle, textStyle]}>
        {beginning}
      </MBText>
      {!isEmpty(end) && (
        <MBText numberOfLines={1} style={textStyle}>
          {end}
        </MBText>
      )}
    </MBView>
  );
}

const truncationStyle: TextStyle = {
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  // @ts-ignore
  display: 'inline-block',
};
